/**************************************************
 * Nombre:       TarjetaHistorial
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Collapse, Grid, Typography} from "@mui/material";
import {formatoFechaHistorial} from "../Utilidades/formatoFechaHistorial";
import {useState} from "react";
import {KeyboardArrowRight, KeyboardArrowUp} from "@mui/icons-material";

const TarjetaHistorial = ({item, index}) => {
    const [open, setOpen] = useState(false);

    const abrir = () => {
        setOpen(!open);
    }

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                borderBottom: 1,
                borderColor: '#00000020'
            }}
        >

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={8}>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: 10}}> {formatoFechaHistorial(item.fecha)}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{lineHeight: 1.1}}>{item.nombre}</Typography>
                </Grid>

            </Grid>

            <Grid container size={4} sx={{justifyContent: 'flex-end'}}>
                <Button
                    variant={'text'}
                    startIcon={open ? <KeyboardArrowUp/> : <KeyboardArrowRight/>}
                    onClick={() => abrir()}>Ver Mas</Button>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                <Collapse in={open} sx={{width: '100%'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{fontSize: 12}}>
                                {item.descripcion}
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end'}}>
                            <Button variant={'text'}>Borrar</Button>
                        </Grid>

                    </Grid>

                </Collapse>
            </Grid>


        </Grid>
    )

}
export default TarjetaHistorial